<footer class="application-footer text-default-color">
  <div class="boi-footer-bg">
    <div class="footer-links w-100">
      <div class="footer-links__half">
        <span
          class="mb-md-0 mb-15"
          [innerHTML]="referenceDataLabels.CopyRightLabel | localizeLabel : currentYear | toTrustedHtml"
        ></span>
      </div>
      <div class="footer-links__half">
        <a
          class="vo-link mb-md-0 mb-15"
          target="_blank"
          [routerLink]="['/', applicationHostTypeService.getCode(), states.PrivacyPolicy]"
          [innerHTML]="
            (applicationHostTypeService.isDirectInterfaceType()
              ? referenceDataLabels.DirectCustomerPrivacyStatement
              : referenceDataLabels.PrivacyAndCookiePolicy
            ) | localizeLabel
          "
        ></a>
        <a
          class="vo-link ml-md-30 mb-md-0 mb-15"
          target="_blank"
          [routerLink]="['/', applicationHostTypeService.getCode(), states.JunkEmails]"
          [innerHTML]="referenceDataLabels.SpamEmails | localizeLabel"
        ></a>
        <a
          class="vo-link ml-md-30 mb-md-0 mb-15"
          target="_blank"
          *ngIf="footerConfigurationService.ShowCookiesPolicyLink"
          [routerLink]="['/', applicationHostTypeService.getCode(), states.CookiesPolicy]"
          [innerHTML]="referenceDataLabels.CookiePolicy | localizeLabel"
        ></a>
      </div>
    </div>
  </div>

  <ng-container *ngIf="applicationHostTypeService.isDirectInterfaceType(); else genericBrokerFooter">
    <div class="footer-details vo-link-inside">
      <ng-container *ngIf="footerConfigurationService.IsOnlineOfferState; else genericDirectFooter">
        <div
          class="mb-15"
          [innerHTML]="footerConfigurationService.OnlineOfferFooterLabel | localizeLabel | toTrustedHtml"
        ></div>
      </ng-container>
      <ng-template #genericDirectFooter>
        <div
          class="mb-15"
          [innerHTML]="footerConfigurationService.FooterTitleLabel | localizeLabel | toTrustedHtml"
        ></div>
        <div
          class="vo-body-bold-16 mb-15"
          [innerHTML]="footerConfigurationService.FooterMonitoringLabel | localizeLabel | toTrustedHtml"
        ></div>
        <div [innerHTML]="footerConfigurationService.FooterContentLabel | localizeLabel | toTrustedHtml"></div>
      </ng-template>
    </div>
  </ng-container>

  <ng-template #genericBrokerFooter>
    <div class="footer-details vo-link-inside">
      <div class="mb-15" [innerHTML]="referenceDataLabels.FooterNote | localizeLabel | toTrustedHtml"></div>
    </div>
  </ng-template>
</footer>
